export const getPointNameExistsError = (name: string) => {
  return (
    <>
      <div>
        {name + ' is already in use.'}
        <div></div>
        {'Please enter a different name'}
      </div>
    </>
  );
};
